
import { Box, Heading, Table, Tbody, Tr, Td, Th, Thead, useToast, Text, Tooltip, Badge, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import { CASE_TYPE } from '../CaseTypeCostant';
import logout from "../services/authService";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import { useSession } from '../SessionContext';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HomeCard() {
  const toast = useToast();
  const [catalog, setCatalog] = useState([]);
  const [message, setMessage] = useState("");

  const { updateSessionData, clearSessionData } = useSession();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });
  /*
  Carica i dataset ottenuti in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con 
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend 
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */

  useEffect(() => {

    const fetchCatalog = async () => {
      try {

        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          caseType: CASE_TYPE.CATALOG_OBTAINED_DATASETS,
        }
        const options = {

          headers: {
            'Content-Type': 'application/json',
          }

        }

        const urlFetch = `${react_api}/privateCatalog/getCatalogADP`;

        const response = await axiosInstance.post(urlFetch, richiesta, options)

        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
        if (result.status === HTTP_STATUS_CODES.OK) {
          setCatalog(result.catalog)
        }
        else {

          setMessage(result.message);
        }
      } catch (error) {
        toast({
          title: t('toastMsg.callError'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    };
    fetchCatalog();
  }
    , []);

  return (

    <Box h="100%" w="100%" >
      <Heading size='md' color={"rgba(11,78,90,255)"} >{t('home.datasetsObtained')}</Heading>
      <Box overflowY="auto" direction="column" h="200px" boxShadow="lg" borderRadius={"10px"}>

        <Table size="sm" variant='striped' bgcolor="white" >
          <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" >
            <Tr>
              <Th color={"white"} w={"15%"} >{t('home.myDatasets.dataset')}</Th>
              <Th color={"white"} w={"15%"}>{t('catalog.dataset.table.categories')}</Th>
              <Th color={"white"} w={"35%"}>{t('catalog.dataset.table.description')}</Th>
              <Th color={"white"} w={"15%"}>Manager</Th>
              <Th color={"white"} w={"20%"}>{t('catalog.dataset.table.visibility')}</Th>

            </Tr>
          </Thead>
          <Tbody>
            {catalog.length > 0 ? (
              (catalog.map((item, index) => (
                <Tr >
                  <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.TBL_NAME}</Td>
                  {/* <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.category}</Td> */}
                  {/* <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                    {Array.isArray(item.category) && (
                      <Tooltip
                        label={item.category.join(", ").length > 10 ? item.category.join(", ") : null}
                        hasArrow
                        placement="bottom-start"
                        openDelay={300}
                        maxW="1000px"
                        whiteSpace="normal"
                      >
                        <Text as="span" cursor="pointer">
                          {item.category.join(", ").length > 50 ? (
                            <>
                              {item.category.join(", ").substring(0, 30)}
                              <Text as="span" color="green.500"> ► </Text>
                            </>
                          ) : (
                            item.category.join(", ")
                          )}
                        </Text>
                      </Tooltip>
                    )}
                  </Td> */}
                  <Td wordBreak={"break-word"} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" maxW="200px">
                    <VStack spacing={2} wrap="wrap" align="start">
                      {item.category.map((cat, idx) => (
                        <Tooltip key={idx} label={cat} hasArrow>
                          <Badge key={idx} color="black" border="1px solid #0888BE" bg="transparent" borderRadius="md" px={1} py={0} maxW="150px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" display="inline-block"
                          >{cat}</Badge>
                        </Tooltip>
                      ))}
                    </VStack>
                  </Td>
                  {/* <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.description}</Td> */}
                  <Td whiteSpace={"normal"} wordBreak={"break-word"} >
                    <Tooltip label={item.description.length > 50 ? item.description : null} hasArrow placement="bottom-start" openDelay={300} maxW="1000px" whiteSpace="normal" >
                      <Text as="span" cursor="pointer">
                        {item.description.length > 50
                          ? (
                            <>
                              {item.description.substring(0, 40)}
                              <Text as="span" color="green.500"> ► </Text>
                            </>
                          )
                          : item.description
                        }
                      </Text>
                    </Tooltip>
                  </Td>
                  <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.OWNER}</Td>
                  {/* <Td whiteSpace={"normal"} wordBreak={"break-word"} >{item.visibility}</Td> */}
                  <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                    <Badge variant='solid' colorScheme={item.visibility === "private" ? "green" : item.visibility === "public" ? "yellow" : item.visibility === "obtained" ? "orange" : item.visibility === "deprecated" ? "red" : "blue"}>
                      {item.visibility}
                    </Badge></Td>
                </Tr>
              )))) : (<Tr alignContent={"center"}><Text fontSize={"lg"} color="rgba(11,78,90,255)">{message ? t(`messageBE.${message}`) : ''}</Text></Tr>)}
          </Tbody>
        </Table>
      </Box>
    </Box>)
}